import styled, { css } from 'styled-components';
import D from '@assets/themes/dimensions';
import C from '@assets/themes/colors';

interface IStyleProps {
  notCoverAll?: boolean;
}

export const Root = styled.div`
  width: 100vw;
  height: 100vh;
  ${(props: IStyleProps) => (props.notCoverAll && css`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    box-sizing: border-box;
    padding: 101px 46px 0px 46px;
  `)}
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${(props: IStyleProps) => (props.notCoverAll && css`
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
    background-color: ${C.WHITE};
    overflow-x: hidden;
    overflow-y: hidden;
    padding: 70px 100px;
    transition: height 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  `)}
`

export const OrangeBar = styled.div`
  width: 100%;
  height: ${D.APP_BAR_HEIGHT}px;
  background-color: ${C.ORANGE};
`

export const SubContainer = styled.div`
  flex: 1;
  max-width: 585px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${(props: IStyleProps) => (props.notCoverAll && css`
    max-width: 764px;
    justify-content: flex-start;
    align-items: flex-start;
  `)}
`

export const Title = styled.div`
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: ${C.ORANGE};
  ${(props: IStyleProps) => (props.notCoverAll && css`
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 20px;
  `)}
`

export const IconContainer = styled.div`
  padding: 20px 0px;
`

export const UpsellIconContainer = styled.div`
  position: absolute;
  bottom: 0px;
  right: 100px;
  width: 500px;
  height: 300px;
`;

export const ButtonContainer = styled.div`
  z-index: 10;
  margin-top: 20px;
`;

export const DescriptionContainer = styled.div`
  width: 100%;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
`

export const Description = styled.div`
`

export const DescriptionList = styled.ul`
`

export const DescriptionItem = styled.li`
  padding: 12px 0px;
`